import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { UrlModule, I18nModule, ConfigModule } from '@spartacus/core';
import { FormModule } from '@spartacus/organization/administration/components';
import { FormErrorsModule, IconModule, SpinnerModule, SplitViewModule } from '@spartacus/storefront';
import { UigBranchFormComponent } from './uig-branch-form.component';
import { AdministrationModule } from '@spartacus/organization/administration';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormModule,
    NgSelectModule,
    UrlModule,
    I18nModule,
    ReactiveFormsModule,
    FormErrorsModule,
    IconModule,
    SplitViewModule,
    SpinnerModule,
    AdministrationModule,
  ],
  declarations: [UigBranchFormComponent],
  exports: [UigBranchFormComponent],
})
export class UigBranchFormModule { }